import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    collapsedTitle: null
};
var originalTitle = document.title || "Pre-Built Solutions";
export var menuMiddleware = function(_) {
    return function(next) {
        return function(action) {
            if (menuSlice.actions.setCollapsedMenuTitle.match(action)) {
                if (action.payload) {
                    document.title = "".concat(action.payload, " - ").concat(originalTitle);
                } else {
                    document.title = originalTitle;
                }
            }
            return next(action);
        };
    };
};
var menuSlice = createSlice({
    initialState: initialState,
    name: "menu",
    reducers: {
        setCollapsedMenuTitle: function(state, param) {
            var payload = param.payload;
            state.collapsedTitle = payload;
        }
    }
});
export var setCollapsedMenuTitle = menuSlice.actions.setCollapsedMenuTitle;
export var menuReducer = menuSlice.reducer;

//# sourceMappingURL=menu.js.map